export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Napisz post...',
  blogsFeedSearchInputPlaceholder: 'Szukaj',
  blogsFeedPostOwnerCurtainEditTitle: 'Edytuj post',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Usuń post',
  blogsFeedEditedPostSavedAlertText: 'Post został zapisany!',
  blogsFeedEditedPostDeletedAlertText: 'Post został usunięty!',
  blogsFeedShareCurtainOptionTitle: 'Skopiuj link',
  blogsFeedPostLinkCopiedAlertText: 'Link został skopiowany!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Skopiuj link',
  blogsFeedOthersPosLinkCopiedAlertText: 'Link został skopiowany!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Zgłoś treść',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Usuń post',
  blogsFeedPostDeletePopupTitle: 'Usuń',
  blogsFeedPostDeletePopupText: 'Czy na pewno chcesz usunąć ten post?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Anuluj',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Potwierdź',
  blogsFeedPostDeeletedAlertText: 'Post został usunięty!',
  blogsPostDetailsHeaderTitle: 'Post',
  postFeedPostLikesText: 'Polubienia',
  postFeedPostCommentsText: 'Komentarze',
  postFeedPostNoLikesText: 'Brak polubień',
  postFeedPostLeaveFirstLikeText: 'Możesz być pierwszy, który polubi ten post',
  blogsFeedPostDetailsNoCommentsText: 'Brak komentarzy',
  blogsFeedPostDetailsFirstCommentText: 'Możesz być pierwszy, który skomentuje ten post',
  blogsFeedPostDetailsShareOptionTitle: 'Skopiuj link',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Link został skopiowany!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Skopiuj link',
  blogsFeedPostDetailsCopiedAlertText: 'Link został skopiowany!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Zgłoś treść',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Zgłoś',
  blogsPostDetailsReportedCurtainText: 'Treść została zgłoszona',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Edytuj komentarz',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Usuń komentarz',
  blogsPostDetailsEditedCommentSavedAlertText: 'Komentarz został zapisany!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Usuń komentarz',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentarz został usunięty!',
  postDetailsDeleteCommentPopupTitle: 'Usuń',
  postDetailsDeleteCommentPopupText: 'Czy na pewno chcesz usunąć ten komentarz?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Anuluj',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potwierdź',
  postDetailsCommDeletedAlertText: 'Komentarz został usunięty!',
  postDetailsCommentUserCurtainOptionTitle: 'Zgłoś komentarz',
  blogsCreatePostCurtainTitle: 'Nowy post',
  blogsCreatePostCurtainBodyPlaceholder: 'Wpisz swoją treść tutaj...',
  blogsCreatePostPublishButtonTitle: 'Opublikuj',
  blogsCreatePostUploadSlallerImageAlertText: 'Możesz przesłać maksymalnie {size} MB naraz',
  blogsPostSavedAlertText: 'Post został zapisany!',
  blogsCreatePostAddLocationCurtainTitle: 'Lokalizacja',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Nazwa lokalizacji',
  blogsCreatePostEditLocationCurtainText: 'Edytuj lokalizację',
  blogsDeleteLocation: 'Usuń lokalizację',
  blogsDiscardPostPopupTitle: 'Wyrzucić',
  blogsDiscardPostPopupText: 'Czy na pewno chcesz odrzucić ten projekt?',
  blogsDiscardPostPopupCancelButtonTitle: 'Anuluj',
  blogsDiscardPostPopupCofirmButtonTitle: 'Potwierdź',
  blogsNewPostCreatePollTitle: 'Utwórz ankietę',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Tytuł',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Opcja',
  blogsNewPostCreatePollAddButtonTitle: 'Dodaj opcję',
  blogsNewPostCreatePollCreateButtonTitle: 'Utwórz',
  blogsCreatePostPollTitleBlankAlertText: 'Tytuł nie może być pusty!',
  blogsCreatePostPollOptionBlankAlertText: 'Opcja nie może być pusta!',
  blogsCreatePostPollLongTitleAlertText: 'Tytuł może zawierać maksymalnie {length} znaków',
  blogsCreatePostPollLongOptionAlertText: 'Opcja może zawierać maksymalnie {length} znaków',
  blogsCreatePostPollEditOptionTitle: 'Edytuj ankietę',
  blogsCreatePostPollRemoveOptionTitle: 'Usuń ankietę',
  blogsPostPollInfoVotesText: 'głosy',
  blogsPostPollInfoEditVoteText: 'Edytuj głos',
  blogsPostPollFinishPollText: 'Zakończ ankietę',
  blogsPostPollFinishedPollText: 'Zakończono',
  blogsPostPollInProgresslText: 'W trakcie',
  blogsFinishPollCurtainTitle: 'Zakończ ankietę',
  blogsFinishPollCurtainText: 'Użytkownicy nie będą mogli głosować po zakończeniu ankiety.',
  blogsFinishPollCurtainCancelButtonTitle: 'Anuluj',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Potwierdź',
  blogsPollInfoPollVotesCurtainTitle: 'Głosy w ankiecie',
  blogsEditPostCurtainTitle: 'Edytuj post',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Wpisz swoją treść tutaj...',
  blogsEditPostCurtainSaveButtonTitle: 'Zapisz',
  blogsEditPostSavedAlertText: 'Post został zapisany!',
  blogsError: 'Coś poszło nie tak!',
  blogsAt: 'o',
  blogsSeeMore: 'Zobacz więcej...',
  blogsMaxAttachments: 'Przekroczyłeś maksymalną liczbę załączników. Maksymalna liczba załączników wynosi {length}',
  blogsReply: 'Odpowiedz',
  blogsAddCover: 'Dodaj okładkę'
}
